module.exports = "/shifts/components/unavailabilityDetailsView-cf04e1.html";